import {
    MinusSquareIcon,
    MoreHorizontalIcon,
    MoveIcon,
    PlusSquareIcon
} from '../icons'
import { Typography } from 'antd'
import * as React from 'react'
import {
    DragHandleWrapperProps,
    TreeOptions,
    NodeWrapperProps,
    TreeModes,
    TreeNodeUnflattened,
    UseDndTreeActionsProps
} from './dtos'
import { DnDTreeContainer } from './hooks'

import * as styles from './DnDTree.module.less'
import * as dragHandleStyles from './DragHandleWrapper.module.less'

const { Text } = Typography

export const NodeWrapper: React.FC<NodeWrapperProps> = (props) => {
    const { hasChildren, isList, node } = props
    const { expandedNodes } = DnDTreeContainer.useContainer().state
    // @ts-ignore
    const isExpanded = expandedNodes[node?.data.id]?.isExpanded
    const isCollapsed = !isExpanded
    const expandCollapseNode = hasChildren ? (
        <input
            type="checkbox"
            id={node?.data.id || undefined}
            checked={isExpanded}
            onChange={undefined}
        />
    ) : null

    const nodeOuterWrapper = (
        <NodeOuterWrapper {...props} isExpanded={isExpanded} />
    )

    // Center all org and add expand / collapse
    const nodeWrapper = isList ? (
        <div className={'nodeContainer'}>{nodeOuterWrapper}</div>
    ) : (
        <div className={`${styles.orgNodeCenterWrapper} nodeContainer`}>
            {nodeOuterWrapper}
        </div>
    )

    return (
        <React.Fragment>
            {expandCollapseNode}
            {nodeWrapper}
            {hasChildren ? (
                isCollapsed ? (
                    <div className={styles.helperIsCollapsed} />
                ) : null
            ) : null}
        </React.Fragment>
    )
}

const NodeOuterWrapper: React.FC<NodeWrapperProps & { isExpanded: boolean }> = (
    props
) => {
    const {
        actions,
        treeOptions,
        hasChildren,
        hasParent,
        isChildOfOrg,
        isExpanded,
        isFirstChild,
        isLastChild,
        isList,
        node
    } = props
    const { Node: NodeComponent } = DnDTreeContainer.useContainer().components
    const { treeModes } = DnDTreeContainer.useContainer().modes
    const { activeNode, state, onNodeClicked } = DnDTreeContainer.useContainer()

    const isOrg = !isList

    const nodeInnerWrapperProps: NodeInnerWrapperProps = {
        actions,
        // @ts-ignore
        activeNode,
        hasChildren,
        isDraggedNode: state.draggingId === node?.data.id,
        isExpanded,
        isList,
        node,
        NodeComponent,
        // @ts-ignore
        onNodeClicked,
        // @ts-ignore
        treeOptions,
        treeModes
    }

    const nodeInnerWrapper = <NodeInnerWrapper {...nodeInnerWrapperProps} />

    if (isOrg && !hasChildren && !hasParent) {
        /*
         *       _______
         *      |  Org  |
         *      |_______|
         *
         */
        return (
            <div className={`${styles.orgNodeNoParentNoChildrenWrapper} node`}>
                {nodeInnerWrapper}
            </div>
        )
    } else if (isOrg && hasChildren && !hasParent) {
        /*
         *       _______
         *      |  Org  |
         *      |_______|
         *          |
         */
        return (
            <div
                className={`${styles.orgNodeNoParentWithChildrenWrapper} node`}
            >
                {nodeInnerWrapper}
            </div>
        )
    } else if (
        hasParent &&
        isChildOfOrg &&
        !isFirstChild &&
        !isLastChild &&
        isOrg
    ) {
        /*     ____ ____
         *       ___|___
         *      |  org  |
         *      |_______|
         */
        return (
            <div
                className={`${styles.orgNodeWithOrgParentWithChildrenMidPositionWrapper} node`}
            >
                <div
                    className={
                        styles.orgNodeWithOrgParentWithChildrenMidPositionWrapper
                    }
                >
                    {nodeInnerWrapper}
                </div>
                <div className={styles.helperBorderTopRight} />
            </div>
        )
    } else if (
        (hasParent &&
            isChildOfOrg &&
            isFirstChild &&
            !isLastChild &&
            !hasChildren &&
            isOrg) ||
        (hasParent &&
            isChildOfOrg &&
            isFirstChild &&
            !isLastChild &&
            hasChildren &&
            !isOrg) ||
        (hasParent &&
            isChildOfOrg &&
            isFirstChild &&
            !isLastChild &&
            !hasChildren &&
            !isOrg)
    ) {
        /*          ____
         *       ___|___
         *      |  org  |
         *      |_______|
         */
        return (
            <React.Fragment>
                <div
                    className={`${styles.firstChildOfOrgTreeNodeWrapper} node`}
                >
                    <div className={styles.firstNodeWithOrgParentWrapper}>
                        {nodeInnerWrapper}
                    </div>
                    <div className={styles.helperBorderTopRight} />
                </div>
            </React.Fragment>
        )
    } else if (
        hasParent &&
        isChildOfOrg &&
        isFirstChild &&
        !isLastChild &&
        hasChildren &&
        isOrg
    ) {
        /*          ____
         *       ___|___
         *      |  org  |
         *      |_______|
         *          |
         */
        return (
            <React.Fragment>
                <div className={styles.helperBorderTopLeft} />
                <div
                    className={`${styles.firstChildOfOrgTreeNodeWrapper} node`}
                >
                    <div
                        className={
                            styles.firstOrgNodeWithOrgParentAndChildrenWrapper
                        }
                    >
                        {nodeInnerWrapper}
                    </div>
                </div>
                <div className={styles.helperBorderTopRight} />
            </React.Fragment>
        )
    } else if (!hasParent && isList) {
        /*
         *       _______
         *      | list  |
         *      |_______|
         *        |
         */
        return (
            <div className={`${styles.listRootSiblingNodeWrapper} node`}>
                {nodeInnerWrapper}
            </div>
        )
    } else if (
        hasParent &&
        isChildOfOrg &&
        !isFirstChild &&
        !isLastChild &&
        isList
    ) {
        /*  _______________
         *  |    ___|___    |
         *      | list? |
         *      |_______|
         */
        return (
            <div className={`${styles.listTreeRootNodeWrapper} node`}>
                <div
                    className={
                        styles.listNodeWithOrgParentNotLastNotFirstWrapper
                    }
                >
                    {nodeInnerWrapper}
                </div>
            </div>
        )
    } else if (hasParent && isChildOfOrg && isFirstChild && isLastChild) {
        /*         1
         *       ___|___
         *      |  any  |
         *      |_______|
         */
        return (
            <div className={`${styles.listTreeRootNodeWrapper} node`}>
                <div
                    className={
                        styles.listNodeWithOrgParentNotLastNotFirstWrapper
                    }
                >
                    {nodeInnerWrapper}
                </div>
            </div>
        )
    } else if (isList && isChildOfOrg && !isFirstChild && isLastChild) {
        /*      ___
         *       ___|___
         *      |  List |
         *      |_______|
         */
        return (
            <div className={`${styles.listTreeRootNodeWrapper} node`}>
                <div className={styles.lastListNodeWithOrgParentWrapper}>
                    {nodeInnerWrapper}
                </div>
            </div>
        )
    } else if (
        isOrg &&
        isChildOfOrg &&
        !isFirstChild &&
        isLastChild &&
        !hasChildren
    ) {
        /*      ___
         *   ___|___
         *  |  Org  |
         *  |_______|
         */
        return (
            <div className={`${styles.orgTreeChildrenWrapper} node`}>
                <div
                    className={styles.lastOrgNodeWithOrgParentNoChildrenWrapper}
                >
                    YIHA{nodeInnerWrapper}
                </div>
            </div>
        )
    } else if (
        isOrg &&
        isChildOfOrg &&
        !isFirstChild &&
        isLastChild &&
        hasChildren
    ) {
        /*      ___
         *   ___|___
         *  |  Org  |
         *  |_______|
         *      |
         */
        return (
            <div className={`${styles.orgTreeChildrenWrapper} node`}>
                <div className={styles.lastOrgNodeWithOrgParentWrapper}>
                    {nodeInnerWrapper}
                </div>
            </div>
        )
    } else if (isList && !isChildOfOrg && !isLastChild) {
        /*
         *    |  _______
         *    |_|  List |
         *    | |_______|
         */
        return (
            <div className={`${styles.listNodeNotLastChildWrapper} node`}>
                {nodeInnerWrapper}
            </div>
        )
    } else if (isOrg && !isChildOfOrg && !isLastChild) {
        /*
         *    |  _______
         *    |_|  Org  |
         *    | |_______|
         */
        return (
            <div
                className={`${styles.orgNodeWithListParentAndMoreSiblingsWrapper} node`}
            >
                {nodeInnerWrapper}
            </div>
        )
    } else if (isList && hasParent && !isChildOfOrg && isLastChild) {
        /*
         *    |  _______
         *    |_| List  |
         *      |_______|
         */
        return (
            <div className={`${styles.listLastSiblingNodeWrapper} node`}>
                {nodeInnerWrapper}
            </div>
        )
    } else if (isOrg && hasParent && !isChildOfOrg && isLastChild) {
        /*
         *    |  _______
         *    |_|  Org  |
         *      |_______|
         */
        return (
            <div className={`${styles.listLastSiblingNodeWrapper} node`}>
                {nodeInnerWrapper}
            </div>
        )
    } else {
        const strippedDown = {
            children: undefined,
            node: { ...props.node, children: undefined }
        }
        // Strips down objects to props that matter, and compare if needs rendering
        const newProps = Object.assign({}, props, strippedDown)
        return (
            <pre>
                Small issue: This node does not have a design yet.{' '}
                {JSON.stringify(newProps, null, 2)}
            </pre>
        )
    }
}

const ExpandCollapseButton: React.FC<{
    hasChildren: boolean
    id: string
    isExpanded: boolean
}> = (props) => {
    const { hasChildren, id, isExpanded } = props
    const { collapseNode, expandNode } = DnDTreeContainer.useContainer().actions

    if (!hasChildren) {
        return null
    }

    const icon = isExpanded ? (
        <MinusSquareIcon
            twoToneColor="hsl(216, 20%, 60%)"
            style={{ cursor: 'pointer' }}
        />
    ) : (
        <React.Fragment>
            <PlusSquareIcon
                twoToneColor="hsl(216, 20%, 60%)"
                style={{ cursor: 'pointer' }}
            />
            <MoreHorizontalIcon
                style={{ marginLeft: '4px', cursor: 'pointer' }}
            />
        </React.Fragment>
    )

    // onClick expand / collapse button
    const onClick = () => {
        isExpanded ? collapseNode(id) : expandNode(id)
    }

    return (
        <div style={{ position: 'absolute', zIndex: 2 }}>
            <div className={styles.expandCollapseButton}>
                <label htmlFor={id || undefined} onClick={onClick}>
                    {icon}
                </label>
            </div>
        </div>
    )
}

interface NodeInnerWrapperProps {
    actions: UseDndTreeActionsProps
    activeNode: string
    hasChildren: boolean
    isDraggedNode: boolean
    isExpanded: boolean
    isList: boolean
    node: TreeNodeUnflattened
    NodeComponent: React.FC<any>
    onNodeClicked: (nodeId: string) => void
    treeOptions: TreeOptions
    treeModes: TreeModes
}
const defaultCanExpandCollapse = false

const NodeInnerWrapper: React.FC<NodeInnerWrapperProps> = (props) => {
    const {
        actions,
        activeNode,
        hasChildren,
        isDraggedNode,
        isExpanded,
        isList,
        node,
        NodeComponent,
        onNodeClicked,
        treeOptions,
        treeModes
    } = props
    const canExpandCollapse = treeOptions
        ? treeOptions.canExpandCollapse !== undefined
            ? treeOptions.canExpandCollapse
            : defaultCanExpandCollapse
        : defaultCanExpandCollapse
    const isOrg = !isList
    return (
        <React.Fragment>
            <div className={styles.borderTopLeft} />
            <div className={styles.nodeTopMargin} />
            <div className={styles.nodeTopLeft} />
            <div className={styles.nodeTopRight} />
            <div className={styles.borderTopMidLeft} />
            <div className={styles.borderBottomMidLeft} />
            <div className={styles.borderBottomLeft} />
            <div className={styles.nodeBottomLeft}>
                {isList && canExpandCollapse ? (
                    <ExpandCollapseButton
                        id={node?.data.id || ''}
                        isExpanded={isExpanded}
                        hasChildren={hasChildren}
                    />
                ) : null}
            </div>
            <div className={styles.nodeBottomRight}>
                {isOrg && canExpandCollapse ? (
                    <ExpandCollapseButton
                        id={node?.data.id || ''}
                        isExpanded={props.isExpanded}
                        hasChildren={hasChildren}
                    />
                ) : null}
            </div>
            <div className={styles.node}>
                <div className={styles.nodeStyles}>
                    <NodeComponent
                        actions={actions}
                        isActive={activeNode === node?.data.id}
                        isDraggedNode={isDraggedNode}
                        node={node}
                        onNodeClicked={onNodeClicked}
                        treeOptions={treeOptions}
                        DragHandle={DragHandleWrapper}
                        treeModes={treeModes}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

const DragHandleWrapper: React.FC<DragHandleWrapperProps> = (props) => {
    const { handle, nodeId } = props
    const dndTreeContainer = DnDTreeContainer.useContainer()
    const canDragDrop = dndTreeContainer.modes.treeModes.dragDropMode
    const { onMouseDownHandle, onMouseUpHandle } = dndTreeContainer.events

    const className = canDragDrop
        ? `dnd-drag-handle ${dragHandleStyles.dragHandleWrapper} ${dragHandleStyles.canDragDrop}`
        : dragHandleStyles.dragHandleWrapper

    return (
        <div
            className={className}
            onMouseDown={(e) => {
                e.preventDefault()
                onMouseDownHandle(nodeId)
            }}
            onMouseMove={(e) => {
                e.preventDefault()
            }}
            onMouseUp={() => onMouseUpHandle(nodeId)}
        >
            {handle || (
                <Text
                    type="secondary"
                    style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                >
                    <MoveIcon />
                </Text>
            )}
        </div>
    )
}
